/* RUGSAK Alpha "Wahle dein Setup" bundle selector.
   Integrates with the theme's existing pub/sub (window.subscribe/publish),
   the existing product form (#{{ product_form_id }}) and the existing
   cart-drawer sections instead of building a second variant system,
   a second cart drawer or a second Add to Cart button. */
(function () {
  if (window.customElements && customElements.get('bundle-setup-selector')) return;

  function moneyFromCents(cents, formatted) {
    return formatted || (cents / 100).toFixed(2);
  }

  class BundleSetup extends HTMLElement {
    connectedCallback() {
      var dataScript = this.querySelector('[data-bundle-setup-json]');
      if (!dataScript) return;
      try {
        this.data = JSON.parse(dataScript.textContent);
      } catch (e) {
        return;
      }

      this.sectionId = this.dataset.sectionId;
      this.formId = this.dataset.productFormId;
      this.option = this.dataset.defaultOption === 'bundle' ? 'bundle' : 'backpack';
      this.submitting = false;
      this.bundleAvailable = true;

      this.cards = {
        backpack: this.querySelector('[data-option="backpack"]'),
        bundle: this.querySelector('[data-option="bundle"]')
      };
      if (!this.cards.backpack || !this.cards.bundle) return;

      this.form = this.formId ? document.getElementById(this.formId) : null;
      this.hiddenIdInput = this.form ? this.form.querySelector('.product-variant-id') : null;
      this.submitButton = this.form ? this.form.querySelector('button[name="add"]') : null;
      this.spinner = this.submitButton ? this.submitButton.querySelector('.loading-overlay__spinner') : null;
      this.errorWrapper = this.form ? this.form.closest('product-form') : null;
      this.errorWrapper = this.errorWrapper ? this.errorWrapper.querySelector('.product-form__error-message-wrapper') : null;
      this.errorMessageEl = this.errorWrapper ? this.errorWrapper.querySelector('.product-form__error-message') : null;

      this._onCardClick = this._onCardClick.bind(this);
      this._onCardKeydown = this._onCardKeydown.bind(this);
      this._onVariantChange = this._onVariantChange.bind(this);
      this._onFormSubmit = this._onFormSubmit.bind(this);

      var self = this;
      Object.keys(this.cards).forEach(function (key) {
        self.cards[key].addEventListener('click', self._onCardClick);
        self.cards[key].addEventListener('keydown', self._onCardKeydown);
      });

      if (typeof window.subscribe === 'function') {
        this._unsubscribeVariant = window.subscribe('variant-change', this._onVariantChange);
      }

      if (this.form) {
        this.form.addEventListener('submit', this._onFormSubmit, true);
      }

      this._applyVariant(this.data.currentVariantId, { initial: true });
      this._setOption(this.option, { silent: true });
      this._syncDynamicCheckout();
    }

    disconnectedCallback() {
      var self = this;
      if (this._unsubscribeVariant) this._unsubscribeVariant();
      if (this.cards) {
        Object.keys(this.cards).forEach(function (key) {
          self.cards[key].removeEventListener('click', self._onCardClick);
          self.cards[key].removeEventListener('keydown', self._onCardKeydown);
        });
      }
      if (this.form) this.form.removeEventListener('submit', this._onFormSubmit, true);
    }

    /* ---------- variant sync (Section 9) ---------- */

    _onVariantChange(evt) {
      var variant = evt && evt.data && evt.data.variant;
      if (!variant) return;
      this._applyVariant(variant.id);
    }

    _applyVariant(alphaVariantId, opts) {
      opts = opts || {};
      /* Always source from the embedded JSON (this.data.alphaVariants), never
         from the raw pub/sub payload directly: the theme's 'variant-change'
         event carries Shopify's native variant shape (featured_image.src,
         no priceFormatted), which does not match the shape this component
         expects. Looking the variant up by id keeps one consistent shape. */
      var alpha = this.data.alphaVariants[String(alphaVariantId)];
      if (!alpha) return;

      var color = alpha.title;
      var hipBelt = this.data.hipBeltByColor[color] || null;
      var rainCover = this.data.rainCover;

      this.currentAlpha = alpha;
      this.currentHipBelt = hipBelt;

      var backpackSubtitle = this.cards.backpack.querySelector('[data-role="backpack-subtitle"]');
      var backpackPrice = this.cards.backpack.querySelector('[data-role="backpack-price"]');
      if (backpackSubtitle) backpackSubtitle.textContent = this.data.backpackSubtitleTemplate.replace('[color]', color);
      if (backpackPrice) backpackPrice.textContent = alpha.priceFormatted;

      var upgradeCents = Math.max(0, this.data.targetPrice - alpha.price);
      var upgradeEl = this.cards.bundle.querySelector('[data-role="upgrade-price"]');
      if (upgradeEl) {
        upgradeEl.textContent = this.data.upgradePrefixText + ' +' + new Intl.NumberFormat(
  this.data.currency === 'CHF' ? 'de-CH' : 'de-DE',
  {
    style: 'currency',
    currency: this.data.currency
  }
).format(upgradeCents / 100);
      }

      var benefitHipBelt = this.cards.bundle.querySelector('[data-role="benefit-hipbelt"]');
      if (benefitHipBelt) benefitHipBelt.textContent = this.data.hipbeltBenefitTemplate.replace('[color]', color);

      var savingsEl = this.cards.bundle.querySelector('[data-role="benefit-savings"]');
      if (savingsEl && hipBelt && rainCover) {
        var regular = alpha.price + hipBelt.price + rainCover.price;
        var savingsCents = Math.max(0, regular - this.data.targetPrice);
        var savingsFormatted = new Intl.NumberFormat(
  this.data.currency === 'CHF' ? 'de-CH' : 'de-DE',
  {
    style: 'currency',
    currency: this.data.currency
  }
).format(savingsCents / 100);
        savingsEl.textContent = this.data.savingsTemplate.replace('[amount]', savingsFormatted);

        var regularPriceEl = this.cards.bundle.querySelector('[data-role="bundle-regular-price"]');
        if (regularPriceEl) {
  regularPriceEl.textContent = new Intl.NumberFormat(
    this.data.currency === 'CHF' ? 'de-CH' : 'de-DE',
    {
      style: 'currency',
      currency: this.data.currency
    }
  ).format(regular / 100);
}
      }

      var imgAlpha = this.cards.bundle.querySelector('[data-role="img-alpha"]');
      if (imgAlpha && alpha.image) {
        imgAlpha.src = alpha.image;
        imgAlpha.alt = color;
      }
      var imgHipBelt = this.cards.bundle.querySelector('[data-role="img-hipbelt"]');
      if (imgHipBelt && hipBelt && hipBelt.image) {
        imgHipBelt.src = hipBelt.image;
        imgHipBelt.alt = color;
      }

      var bundleAvailable = !!(alpha.available && hipBelt && hipBelt.available && rainCover && rainCover.available);
      this._setBundleAvailability(bundleAvailable);

      if (!opts.initial) this._syncDynamicCheckout();
    }

    /* ---------- availability (Section 13) ---------- */

    _setBundleAvailability(available) {
      this.bundleAvailable = available;
      var note = this.cards.bundle.querySelector('[data-role="unavailable-note"]');
      this.cards.bundle.classList.toggle('bundle-setup__card--unavailable', !available);
      this.cards.bundle.setAttribute('aria-disabled', available ? 'false' : 'true');
      if (note) note.hidden = available;

      if (!available && this.option === 'bundle') {
        this._setOption('backpack');
      }
    }

    /* ---------- selection (Sections 5 & 8) ---------- */

    _onCardClick(evt) {
      var card = evt.currentTarget;
      var option = card.dataset.option;
      if (option === 'bundle' && !this.bundleAvailable) return;
      this._setOption(option);
    }

    _onCardKeydown(evt) {
      var keys = ['ArrowUp', 'ArrowDown', 'ArrowLeft', 'ArrowRight'];
      if (keys.indexOf(evt.key) !== -1) {
        evt.preventDefault();
        var next = this.option === 'backpack' ? 'bundle' : 'backpack';
        if (next === 'bundle' && !this.bundleAvailable) return;
        this._setOption(next);
        this.cards[next].focus();
      } else if (evt.key === ' ' || evt.key === 'Enter') {
        evt.preventDefault();
        this._onCardClick(evt);
      }
    }

    _setOption(option, opts) {
      opts = opts || {};
      if (option === 'bundle' && !this.bundleAvailable) option = 'backpack';
      this.option = option;

      var self = this;
      Object.keys(this.cards).forEach(function (key) {
        var isActive = key === option;
        var card = self.cards[key];
        card.classList.toggle('bundle-setup__card--active', isActive);
        card.setAttribute('aria-checked', isActive ? 'true' : 'false');
        card.setAttribute('tabindex', isActive ? '0' : '-1');
      });

      if (!opts.silent) this._syncDynamicCheckout();
    }

    /* ---------- dynamic checkout (Section 14) ---------- */

    _syncDynamicCheckout() {
      if (!this.form) return;
      var paymentButton = this.form.querySelector('.shopify-payment-button');
      if (!paymentButton) return;
      paymentButton.style.display = this.option === 'bundle' ? 'none' : '';
    }

    /* ---------- add to cart (Sections 10-12) ---------- */

    _onFormSubmit(evt) {
      if (this.option !== 'bundle') return; /* Nur Rucksack: existing form submits exactly as before */

      evt.preventDefault();
      evt.stopImmediatePropagation();

      if (this.submitting) return;
      if (!this.currentAlpha || !this.currentHipBelt || !this.data.rainCover || !this.bundleAvailable) {
        this._showError(this.data.strings.unavailable);
        return;
      }

      var alphaVariantId = this.hiddenIdInput ? parseInt(this.hiddenIdInput.value, 10) : this.currentAlpha.id;
      var items = [
        { id: alphaVariantId, quantity: 1 },
        { id: this.currentHipBelt.id, quantity: 1 },
        { id: this.data.rainCover.id, quantity: 1 }
      ];

      this._setLoading(true);

      var sectionsToRender = this._sectionIdsOnPage();

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: items, sections: sectionsToRender.join(','), sections_url: window.location.pathname })
      })
        .then(function (res) {
          return res.json().then(function (data) {
            if (!res.ok) throw data;
            return data;
          });
        })
        .then(this._onAddSuccess.bind(this))
        .catch(this._onAddError.bind(this))
        .then(
          function () {
            this._setLoading(false);
          }.bind(this)
        );
    }

    _sectionIdsOnPage() {
      var ids = [];
      document.querySelectorAll('[id^="shopify-section-"]').forEach(function (el) {
        var id = el.id.replace('shopify-section-', '');
        if (id.indexOf('cart-drawer') !== -1 || id.indexOf('cart-icon-bubble') !== -1 || id.indexOf('cart-notification') !== -1) {
          ids.push(id);
        }
      });
      if (!ids.length) ids = ['cart-drawer', 'cart-icon-bubble'];
      return ids;
    }

    _onAddSuccess(data) {
      this._clearError();

      if (data.sections) {
        Object.keys(data.sections).forEach(function (sectionId) {
          var html = data.sections[sectionId];
          var wrapper = document.getElementById('shopify-section-' + sectionId);
          if (wrapper) {
            var parsed = new DOMParser().parseFromString(html, 'text/html');
            var fresh = parsed.getElementById('shopify-section-' + sectionId);
            if (fresh) wrapper.innerHTML = fresh.innerHTML;
            return;
          }
          /* cart-icon-bubble renders without a shopify-section wrapper on this theme */
          var bare = document.getElementById(sectionId);
          if (bare) bare.innerHTML = html;
        });
      }

      var cartDrawer = document.querySelector('cart-drawer');
      if (cartDrawer && typeof cartDrawer.open === 'function') cartDrawer.open();

      /* Deliberately NOT calling window.publish('cart-update', ...) here: the
         section HTML injected above is already the full native server-rendered
         cart-drawer markup. Publishing cart-update in addition to that makes the
         theme's own CartDrawerItems (extends CartItems) subscriber run a second,
         conflicting re-render that — for this multi-item payload shape — swaps in
         the cart PAGE's table markup (#main-cart-items) instead of the drawer's
         list markup, breaking the layout. Verified by isolating the two steps. */
    }

    _onAddError(err) {
      var message = (err && (err.description || err.message)) || this.data.strings.genericError;
      this._showError(message);
    }

    _setLoading(loading) {
      this.submitting = loading;
      if (this.submitButton) this.submitButton.disabled = loading;
      if (this.spinner) this.spinner.classList.toggle('hidden', !loading);
    }

    _showError(message) {
      if (this.errorMessageEl) this.errorMessageEl.textContent = message;
      if (this.errorWrapper) this.errorWrapper.hidden = false;
    }

    _clearError() {
      if (this.errorWrapper) this.errorWrapper.hidden = true;
    }
  }

  customElements.define('bundle-setup-selector', BundleSetup);
})();
